module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
'use strict';

(function (fox) {
	var _Promise = fox.RSVP.Promise;

	fox.registerWidget('PromisePreloader', {
		configure: function () {
			this.registerOptions('', {
				autoRender: true,
				template: 'big_preloader'
			});

			this.callParent('configure', arguments);
		},

		running: function () {
			this._readyToEmbed = false;

			this.callParent('running', arguments);
		},

		show: function (promise) {
			if (!(promise instanceof _Promise)) return _Promise.resolve(false);

			function retPromise (promise) {
				this.render();

				return promise;
			}

			this._readyToEmbed = true;

			var resPromise = this.wait('addedToDom').then(function () {
				this._readyToEmbed = false;

				return promise;
			}.bind(this)).then(function (resp) {
				if (this.isEmbedded()) this.removeFromDom();

				this.visualParent.render();

				return resp;
			}.bind(this));

			if (!this.isActive()) return this.wait('activate').then(retPromise.bind(this, resPromise));

			return retPromise.call(this, resPromise);
		}
	});
})(fox);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/widget/promisePreloader.js
// module id = 868
// module chunks = 4